import { useState } from 'react'
import { InfoButton } from '@/shared/components/ui/InfoButton'
import { LeagueFormat, LeagueTransferOption, type League } from '../types'
import { LeagueRulesSheet } from './LeagueRulesSheet'
import styles from './LeagueInfoCard.module.css'

type LeagueInfoCardProps = {
  league: League
}

export function LeagueInfoCard({ league }: LeagueInfoCardProps) {
  const [showRules, setShowRules] = useState(false)
  const formatLabel = league.format === LeagueFormat.HeadToHead ? 'Head-to-Head' : 'Pontos Gerais'
  const transferLabel =
    league.transferOption === LeagueTransferOption.OptionA ? '3 por rodada' : 'Ilimitadas'

  const rows: { k: string; v: string }[] = [
    { k: 'Formato', v: formatLabel },
    { k: 'Pontuação', v: 'Nossa Preset' },
    { k: 'Transferências', v: transferLabel },
    { k: 'Participantes', v: `${league.memberCount} / ${league.maxParticipants}` },
  ]

  return (
    <div className={styles.card}>
      <div className={styles.head}>
        <span className={styles.title}>Sobre a liga</span>
        <InfoButton label="Ver regras da liga" onClick={() => setShowRules(true)} />
      </div>
      <div className={styles.rows}>
        {rows.map((row) => (
          <div key={row.k} className={styles.row}>
            <span className={styles.k}>{row.k}</span>
            <span className={styles.v}>{row.v}</span>
          </div>
        ))}
      </div>

      {showRules && <LeagueRulesSheet league={league} onClose={() => setShowRules(false)} />}
    </div>
  )
}
